/**
 * Capabilities:
 * - CAP-MEMBER-ONBOARDING
 * - CAP-MEMBER-SELF-SERVICE
 * - CAP-VOUCHER-REDEMPTION
 * - CAP-PROMOTION-PARTICIPATION
 * - CAP-STAFF-MEMBER-ADMINISTRATION
 * - CAP-STAFF-VOUCHER-ADMINISTRATION
 * - CAP-STAFF-SCHEDULED-MESSAGING
 * - CAP-STAFF-AUDIT-REVIEW
 * - CAP-STAFF-METRICS
 * - CAP-STAFF-OPERATIONS-SUPPORT
 * - CAP-OUTLET-STOCK-CONTROL
 * - CAP-OUTLET-REDEMPTION-CODE
 * - CAP-REALTIME-STAFF-UPDATES
 *
 * Responsibilities:
 * - Configure the browser application's shared AWS, REST, and WebSocket
 *   clients from Amplify outputs.
 * - Define the top-level router that dispatches traffic into the member,
 *   staff, and outlet application shells.
 *
 * Context:
 * - project-intelligence/architecture/frontend-applications.md
 * - project-intelligence/generated/frontend-routes.md
 * - project-intelligence/generated/api-routes.md
 */

// Set globalThis for old browsers
import './utils/global-this-polyfill';

import { Amplify, Auth } from 'aws-amplify';
import awsExports from './aws-exports';

import React from 'react';
import ReactDOM from 'react-dom/client';

// import { Provider } from 'react-redux'
import store from './utils/store'

import {
    createBrowserRouter,
    RouterProvider,
    // Route,
} from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import { MainApp } from './Components/';
import { OperationsApp } from './Components/';
import { TelegramApp, TelegramAppRegistration, TelegramAppLink, Redirect } from './Components/';
import reportWebVitals from './reportWebVitals';

import _ from 'underscore';
import axios from 'axios';
import moment from 'moment-timezone';
import ReconnectingWebSocket from 'reconnecting-websocket';

import WSUtils from './utils/ws-utils';
import RESTUtils from './utils/rest-utils';
import ChatUtils from './utils/chat-utils';

// import { exposeIfDev, doIfDev, isDev } from './utils/general-utils';
import { exposeIfDev, doIfDev } from './utils/general-utils';

exposeIfDev({
    React, ReactDOM,
    store,
    Amplify, Auth,
    _,
    axios,
    moment,
    ReconnectingWebSocket,
    WSUtils, RESTUtils,
    ChatUtils,
    awsExports,
})

Amplify.configure(awsExports);
doIfDev(() => {
    console.log('Amplify Config', awsExports);

    const faviconEl = Array.from(document.head.getElementsByTagName('link'))
        .filter(el => el.getAttribute('rel') === 'icon')[0];
    if (!!faviconEl) {
        faviconEl.setAttribute('href', 'favicon--dev.png')
    }
});

RESTUtils.setEndpoint(awsExports.aws_chalice_api_resources.rest_api.rest_api_url);
if (!!awsExports.aws_chalice_api_resources.api_gateway_custom_domain) {
    const customDomainInfo = awsExports.aws_chalice_api_resources.api_gateway_custom_domain;
    const apiMappings = customDomainInfo.api_mapping || [];
    if (apiMappings.length === 1) {
        const new_api_url = (
            ((!!customDomainInfo.certificate_arn && !!customDomainInfo.security_policy) ? 'https://' : 'http://')
            +
            customDomainInfo.domain_name
            +
            apiMappings[0].key
        )
        RESTUtils.setEndpoint(new_api_url);
    }
}

WSUtils.setEndpoint(awsExports.aws_chalice_api_resources.websocket_api.websocket_api_url, false);
if (!!awsExports.aws_chalice_api_resources.websocket_api_custom_domain) {
    const customDomainInfo = awsExports.aws_chalice_api_resources.websocket_api_custom_domain;
    const apiMappings = customDomainInfo.api_mapping || [];
    if (apiMappings.length === 1) {
        const new_api_url = (
            ((!!customDomainInfo.certificate_arn && !!customDomainInfo.security_policy) ? 'wss://' : 'ws://')
            +
            customDomainInfo.domain_name
            +
            apiMappings[0].key
        )
        WSUtils.setEndpoint(new_api_url);
    }
}

Amplify.configure({
    API: {
        endpoints: awsExports.aws_cloud_logic_custom
    }
});

const router = createBrowserRouter([
    {
        path: '*',
        element: <MainApp />,
    },
    {
        path: '/operations/*',
        element: <OperationsApp />,
    },
    {
        path: '/telegram-app',
        element: <TelegramApp />,
    },
    {
        path: '/telegram-app/registration',
        element: <TelegramAppRegistration />,
    },
    {
        path: '/telegram-app/link',
        element: <TelegramAppLink />,
    },
    {
        path: '/r',
        element: <Redirect />,
    }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        {/* <Provider store={store}> */}
            <RouterProvider router={router} />
        {/* </Provider> */}
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(info => {
    // if (isDev()) {
    //   console.info('[report-web-vitals]');
    //   Object.keys(info).forEach(k => console.info(` - ${k}:`, info[k]));
    // }
});
